// eslint-disable-next-line no-unused-vars
import React, { PureComponent } from 'react';
import { node, object } from 'prop-types';

import withRouter from 'AppSrc/hocs/withRouter';
import ErrorBoundaryComponent from 'Components/ErrorBoundary/ErrorBoundary';
import CustomError from 'Utils/CustomError';

const initialState = {
  hasError: false,
  hasCustomError: null,
  error: null
};

@withRouter
export default class ErrorBoundary extends PureComponent {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  // componentDidCatch(error, errorInfo) {
  //   console.log('Error caught:', error);
  //   console.log('Component stack:', errorInfo.componentStack);
  //   console.log('Error stack:', error.stack);
  // }

  // componentDidMount() {
  //   window.addEventListener('error', this.handleError, { capture: true });
  // }

  static getDerivedStateFromProps(nextProps) {
    const { location } = nextProps;
    if (location?.state?.networkError) {
      // TODO: should replace history to remove state ?
      // history.replace(location.pathname);
      return { hasError: true, error: nextProps.location.state.networkError };
    }
    return null;
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    if (error instanceof CustomError) {
      return { hasError: true, hasCustomError: true, error };
    }
    return { hasError: true, error };
  }

  componentDidUpdate() {
    const { location, history: { replace } } = this.props;
    if (location?.state?.error) {
      replace({
        pathname: location.pathname,
        hash: location.hash,
        search: location.search
      });
    }
  }

  // componentWillUnmount() {
  //   window.removeEventListener('error', this.handleError);
  // }

  // handleError = event => {
  //   const { error } = event;
  //   // Skip the first error, it is always irrelevant in the DEV mode.
  //   if (error.stack?.indexOf('invokeGuardedCallbackDev') >= 0 && !error.alreadySeen) {
  //     error.alreadySeen = true;
  //     event.preventDefault();
  //     return;
  //   }

  //   // Normal error handling.
  //   if (error instanceof CustomError) {
  //     this.setState({ hasError: true, error });
  //   }
  // };

  render() {
    const { hasError, hasCustomError, error } = this.state;
    const { children } = this.props;

    return (
      <ErrorBoundaryComponent
        hasError={ hasError }
        hasCustomError={ hasCustomError }
        error={ error }
        clearError={ () => this.setState({ ...initialState }) }
      >
        { children }
      </ErrorBoundaryComponent>
    );
  }
}

ErrorBoundary.propTypes = {
  location: object,
  history: object,
  children: node
};
